module.exports = __webpack_public_path__ + "static/tw-526482e76826164b6d86e43ba6008818.jpeg";